export default {
    product:'',
    productPrice: '0',
    totalFeet: '0',
    qty: 1,
    inches:'',
    incToFeet: '0',
    totalPrice: '0',
    voltage:'',
    temp:'',
    wraps:0,
    max_inches:400,
    msg:'',

    wireStepOneWire: false,
    wireStepTwo: false,
    wireStepThree: false,
    wireStepFour: false,
    wireStepFive: false,
    wireStepSix: false,
    completedStep: false,
    products:{}
}